// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"AddRampModal_modalForm__2eLOx"};